<template>
    <router-view></router-view>
</template>

<script>
import AlisonLibComponent from './AlisonLibComponent';
import alisonJS from  '@/services/alison_js.js'
import alisonGUI from  '@/services/alison_gui.js'
import * as pack from '../package.json';

export default {
  name: 'App',
  components: {
    
  },
  data: () => {
    return{
      provider: 'DESKTOP',
      version: '',
      guiVersion: '',
      items: [
            { title: 'DESKTOP' },
            { title: 'SERVER' },
          ],
        }
  },
  created(){
    this.alisonGUI_version = alisonGUI.version;
    this.alisonJS_version = alisonJS.version;
    this.botonera_version = pack.version;
  },
  methods: {
    changeProv(prov){
      this.provider = prov.title
    }
  }
};
</script>
